import { StatusCodes } from "http-status-codes";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { Plan, VEBPlan } from "../../../types/plan.types";
import { request } from "../api";

const initialRoute = "plan";
const { get } = request;

export type PlansWithRiderQuery = {
	plan_name: string;
	[key: string]: string;
};

export const getPlansWithRider = async (query: PlansWithRiderQuery): Promise<Plan[]> => {
	try {
		const endpoint = `${initialRoute}/riders`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query,
			4001
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err) {
		alert(err);
		throw err;
	}
};

export const getParticularPlans = async (query: any) => {
	try {
		const endpoint = `${initialRoute}/particular-plan`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
const getVEBPlans = async (query: any): Promise<VEBPlan[]> => {
	try {
		// console.log("Query", query);
		const endpoint = `${initialRoute}/veb-plans?group_number=${query}`;
		const token = localStorage.getItem("@jwt_member");
		console.log("token", token);

		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);

		if (response) {
			// console.log("Response", response);
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;

				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		throw error;
	}
};
export const getPlans = async (query: any): Promise<Plan[]> => {
	try {
		// console.log("query", query);
		const endpoint = `${initialRoute}`;
		const token = localStorage.getItem("@jwt_member");

		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);

		// console.log("response PLans", response);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			if (message === "Unauthorised Role!") {
				alert("Unauthorised Role!");
			} else if (message === MESSAGE.get.empty) {
				alert("Database Empty");
			} else if (message === MESSAGE.post.fail) {
				alert("Failed to get members!");
			} else alert("Other Errors of Status Code 400");
		}
		throw error;
	}
};
export const plan = {
	getPlansWithRider,
	getParticularPlans,
	getVEBPlans,
	getPlans
};
